export default class FileService {

  constructor($q){
    this.$q = $q;
  }

  read(file){
    return this.$q((resolve, reject)=>{
      try {
        var reader = new FileReader();
        reader.onload = function(){
          resolve({
              name: file.name,
              size: file.size,
              content: reader.result
          });
        }
        reader.onerror = function(err){
          reject(err);
        }
        reader.readAsDataURL(file);
      } catch(e) {
        reject(e);
      }
    })
  }

}


// WEBPACK FOOTER //
// ./src/util/FileService.js